import Vue from 'vue'

const state = {
  resposta: [],
  respostas: [],
  carregando: 0
}

const getters = {
  getResposta: state => {
    return state.resposta
  }
}

const mutations = {
  setResposta (state, data) {
    state.resposta = data
  },
  setRespostas (state, data) {
    state.respostas = data
  },
  incrementarCarregando (state) {
    state.carregando++
  },
  decrementarCarregando (state) {
    state.carregando--
  }
}

const actions = {
  getRespostas (context, filtros) {
    if (!filtros.filter) {
      filtros.filter = ''
    }
    if (!filtros.data) {
      filtros.data = ''
    }
    if (!filtros.situacao) {
      filtros.situacao = ''
    }
    if (!filtros.tipoEnvio) {
      filtros.tipoEnvio = ''
    }
    Vue.http.get('api/respostas?id=' + filtros.id +
                            '&filter=' + filtros.filter +
                            '&data=' + filtros.data +
                            '&situacao=' + filtros.situacao +
                            '&tipoEnvio=' + filtros.tipoEnvio).then(response => {
      context.commit('setRespostas', response.body.data.data)
    })
  },
  getResposta (context, id) {
    Vue.http.get('api/resposta/' + id).then(response => {
      context.commit('setResposta', response.data.data[0])
    })
  },
  getRespostaToken (context, data) {
    Vue.http.get('api/externo/resposta/' + data.token + '/' + data.id).then(response => {
      context.commit('setResposta', response.data.data[0])
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/resposta.js